import { getFontFamily, getLineHeight, getFontSize, getTextAlign, getFontWeight, } from '../../typography/typography.alias';
import { getColor } from '../../colors/colors.alias';
import { VARIANT_DEFAULT, VARIANT_ATTENTIONAL_XXL, VARIANT_ATTENTIONAL_XXL_CENTERED, VARIANT_ATTENTIONAL_XL, VARIANT_ATTENTIONAL_XL_CENTERED, VARIANT_XXL, VARIANT_XXL_CENTERED, VARIANT_XL, VARIANT_XL_CENTERED, VARIANT_LARGE, VARIANT_LARGE_CENTERED, VARIANT_MEDIUM, VARIANT_MEDIUM_CENTERED, VARIANT_SMALL, VARIANT_SMALL_CENTERED, VARIANT_XS, VARIANT_XS_CENTERED, ELEMENT_HEADING, } from '../../constants';
export const constants = Object.freeze({
    NAME: 'Heading',
    variants: {
        VARIANT_DEFAULT,
        VARIANT_ATTENTIONAL_XXL,
        VARIANT_ATTENTIONAL_XXL_CENTERED,
        VARIANT_ATTENTIONAL_XL,
        VARIANT_ATTENTIONAL_XL_CENTERED,
        VARIANT_XXL,
        VARIANT_XXL_CENTERED,
        VARIANT_XL,
        VARIANT_XL_CENTERED,
        VARIANT_LARGE,
        VARIANT_LARGE_CENTERED,
        VARIANT_MEDIUM,
        VARIANT_MEDIUM_CENTERED,
        VARIANT_SMALL,
        VARIANT_SMALL_CENTERED,
        VARIANT_XS,
        VARIANT_XS_CENTERED,
    },
    elements: {
        ELEMENT_HEADING,
    },
});
export default function getHeading(transformer, config) {
    const color = getColor(transformer, config);
    const fontFamily = getFontFamily(transformer, config);
    const fontSize = getFontSize(transformer);
    const lineHeight = getLineHeight(transformer);
    const textAlign = getTextAlign(transformer);
    const fontWeight = getFontWeight(transformer);
    return Object.freeze({
        constants,
        elements: {
            [ELEMENT_HEADING]: {
                styles: {
                    /** @deprecated - delete in v12 */
                    fontFamily: fontFamily.heading.value,
                    /** @deprecated - delete in v12 */
                    fontWeight: fontWeight.heading.get(fontFamily.heading.value),
                    color: color.text.attentional.value,
                    textAlign: textAlign.heading.default.value,
                },
                variants: {
                    [VARIANT_ATTENTIONAL_XXL]: {
                        styles: {
                            fontFamily: fontFamily.heading.value,
                            fontWeight: fontWeight.heading.get(fontFamily.heading.value),
                            fontSize: fontSize.heading.xxl.value,
                            lineHeight: lineHeight.heading.get(fontSize.heading.xxl.value),
                            color: color.text.brand.value,
                        },
                    },
                    [VARIANT_ATTENTIONAL_XXL_CENTERED]: {
                        styles: {
                            fontFamily: fontFamily.heading.value,
                            fontWeight: fontWeight.heading.get(fontFamily.heading.value),
                            fontSize: fontSize.heading.xxl.value,
                            lineHeight: lineHeight.heading.get(fontSize.heading.xxl.value),
                            textAlign: textAlign.heading.centered.value,
                            color: color.text.brand.value,
                        },
                    },
                    [VARIANT_ATTENTIONAL_XL]: {
                        styles: {
                            fontFamily: fontFamily.heading.value,
                            fontWeight: fontWeight.heading.get(fontFamily.heading.value),
                            fontSize: fontSize.heading.xl.value,
                            lineHeight: lineHeight.heading.get(fontSize.heading.xl.value),
                            color: color.text.brand.value,
                        },
                    },
                    [VARIANT_ATTENTIONAL_XL_CENTERED]: {
                        styles: {
                            fontFamily: fontFamily.heading.value,
                            fontWeight: fontWeight.heading.get(fontFamily.heading.value),
                            fontSize: fontSize.heading.xl.value,
                            lineHeight: lineHeight.heading.get(fontSize.heading.xl.value),
                            textAlign: textAlign.heading.centered.value,
                            color: color.text.brand.value,
                        },
                    },
                    [VARIANT_XXL]: {
                        styles: {
                            fontFamily: fontFamily.heading.value,
                            fontWeight: fontWeight.heading.get(fontFamily.heading.value),
                            fontSize: fontSize.heading.xxl.value,
                            lineHeight: lineHeight.heading.get(fontSize.heading.xxl.value),
                        },
                    },
                    [VARIANT_XXL_CENTERED]: {
                        styles: {
                            fontFamily: fontFamily.heading.value,
                            fontWeight: fontWeight.heading.get(fontFamily.heading.value),
                            fontSize: fontSize.heading.xxl.value,
                            lineHeight: lineHeight.heading.get(fontSize.heading.xxl.value),
                            textAlign: textAlign.heading.centered.value,
                        },
                    },
                    [VARIANT_XL]: {
                        styles: {
                            fontFamily: fontFamily.heading.value,
                            fontWeight: fontWeight.heading.get(fontFamily.heading.value),
                            fontSize: fontSize.heading.xl.value,
                            lineHeight: lineHeight.heading.get(fontSize.heading.xl.value),
                        },
                    },
                    [VARIANT_XL_CENTERED]: {
                        styles: {
                            fontFamily: fontFamily.heading.value,
                            fontWeight: fontWeight.heading.get(fontFamily.heading.value),
                            fontSize: fontSize.heading.xl.value,
                            lineHeight: lineHeight.heading.get(fontSize.heading.xl.value),
                            textAlign: textAlign.heading.centered.value,
                        },
                    },
                    [VARIANT_LARGE]: {
                        styles: {
                            fontFamily: fontFamily.heading.value,
                            fontWeight: fontWeight.heading.get(fontFamily.heading.value),
                            fontSize: fontSize.heading.l.value,
                            lineHeight: lineHeight.heading.get(fontSize.heading.l.value),
                        },
                    },
                    [VARIANT_LARGE_CENTERED]: {
                        styles: {
                            fontFamily: fontFamily.heading.value,
                            fontWeight: fontWeight.heading.get(fontFamily.heading.value),
                            fontSize: fontSize.heading.l.value,
                            lineHeight: lineHeight.heading.get(fontSize.heading.l.value),
                            textAlign: textAlign.heading.centered.value,
                        },
                    },
                    [VARIANT_MEDIUM]: {
                        styles: {
                            fontFamily: fontFamily.heading.value,
                            fontWeight: fontWeight.heading.get(fontFamily.heading.value),
                            fontSize: fontSize.heading.m.value,
                            lineHeight: lineHeight.heading.get(fontSize.heading.m.value),
                        },
                    },
                    [VARIANT_MEDIUM_CENTERED]: {
                        styles: {
                            fontFamily: fontFamily.heading.value,
                            fontWeight: fontWeight.heading.get(fontFamily.heading.value),
                            fontSize: fontSize.heading.m.value,
                            lineHeight: lineHeight.heading.get(fontSize.heading.m.value),
                            textAlign: textAlign.heading.centered.value,
                        },
                    },
                    /**
                     * Small and XS should not use the heading font family.
                     * That font family is not optimised from smaller font sizes.
                     * This fixes a bug with the Czech language, where some characters with an accent will render too thin on Windows.
                     */
                    [VARIANT_SMALL]: {
                        styles: {
                            fontFamily: fontFamily.strongImportance.value,
                            fontWeight: fontWeight.strongImportance.get(fontFamily.strongImportance.value),
                            fontSize: fontSize.heading.s.value,
                            lineHeight: lineHeight.heading.get(fontSize.heading.s.value),
                        },
                    },
                    [VARIANT_SMALL_CENTERED]: {
                        styles: {
                            fontFamily: fontFamily.strongImportance.value,
                            fontWeight: fontWeight.strongImportance.get(fontFamily.strongImportance.value),
                            fontSize: fontSize.heading.s.value,
                            lineHeight: lineHeight.heading.get(fontSize.heading.s.value),
                            textAlign: textAlign.heading.centered.value,
                        },
                    },
                    [VARIANT_XS]: {
                        styles: {
                            fontFamily: fontFamily.strongImportance.value,
                            fontWeight: fontWeight.strongImportance.get(fontFamily.strongImportance.value),
                            fontSize: fontSize.heading.xs.value,
                            lineHeight: lineHeight.heading.get(fontSize.heading.xs.value),
                        },
                    },
                    [VARIANT_XS_CENTERED]: {
                        styles: {
                            fontFamily: fontFamily.strongImportance.value,
                            fontWeight: fontWeight.strongImportance.get(fontFamily.strongImportance.value),
                            fontSize: fontSize.heading.xs.value,
                            lineHeight: lineHeight.heading.get(fontSize.heading.xs.value),
                            textAlign: textAlign.heading.centered.value,
                        },
                    },
                },
            },
        },
    });
}
